const CHUNK_LOAD_RELOAD_KEY = 'grip-webnetworking:chunk-load-reload';

let reloadPending = false;

function getChunkLoadErrorMessage(error: unknown): string {
  if (typeof error === 'string') {
    return error;
  }

  if (error && typeof error === 'object') {
    const potentialError = error as { message?: string; reason?: { message?: string } };
    return potentialError.message ?? potentialError.reason?.message ?? '';
  }

  return '';
}

export function isChunkLoadError(error: unknown): boolean {
  const message = getChunkLoadErrorMessage(error);

  return /Failed to fetch dynamically imported module|Importing a module script failed|Loading chunk [\w-]+ failed/i.test(message);
}

export function isReloadPending(): boolean {
  return reloadPending;
}

export function clearChunkLoadReloadGuard(): void {
  window.sessionStorage.removeItem(CHUNK_LOAD_RELOAD_KEY);
}

export function recoverFromChunkLoadError(error: unknown, targetUrl?: string): boolean {
  if (!isChunkLoadError(error)) {
    return false;
  }

  const destination = targetUrl ?? `${window.location.pathname}${window.location.search}`;

  if (window.sessionStorage.getItem(CHUNK_LOAD_RELOAD_KEY) === destination) {
    return false;
  }

  window.sessionStorage.setItem(CHUNK_LOAD_RELOAD_KEY, destination);
  reloadPending = true;

  if (targetUrl) {
    window.location.assign(targetUrl);
  } else {
    window.location.reload();
  }

  return true;
}
